import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Loading from "./Loading.tsx";

export default function RequireAuth() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      const returnTo = `${location.pathname}${location.search}`;
      loginWithRedirect({ appState: { returnTo } });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, location.pathname, location.search]);

  if (isLoading || !isAuthenticated) {
    return <Loading />;
  }

  return <Outlet />;
}
